import Component from '../abstracts/Component';

export default class MiniCartComponent extends Component {

  get SELECTORS() {
    return {
      container: '.js-cart-dropdown',
      main: '.js-minicart',
      remove: '.js-removeitem',
      icon: '.action.cart'
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      removing: 'removing'
    };
  }

  constructor() {
    super();
    this.timeout = null;
    this.container = $(this.SELECTORS.container);
    this.main = $(this.SELECTORS.main);
    this.icon = $(this.SELECTORS.icon);
    this.updated = false;
  }


  openMinicart() {
    clearTimeout(this.timeout);
    this.container.addClass(this.CLASSES.show);
    const keyboard = document.querySelector('[data-whatinput="keyboard"]');
    const focusableContainer = document.querySelector(this.SELECTORS.container).querySelector('ul');
    const firstFocusable = this.$getFirstFocusable(focusableContainer);
    setTimeout(() => {
      firstFocusable.focus();
    }, 200);
    if (!keyboard) {
      this.timeout = setTimeout(() => {
        this.container.removeClass(this.CLASSES.show)
      }, 2000);
    }
  }

  updateQty() {
    let qty = this.main.find('.layer-body').data('items-count');
    if (qty > 0) {
      this.icon.append(`<span class="badge qty-icon">${qty}</span>`);
    }
  }

  showEmptyMsg($el) {

    let $layer = $el.find('.layer-body');
    let $footer = $el.find('footer');
    let $icon = this.container.find('.qty-icon')
    let msg = $layer.data('empty-msg');

    $layer.addClass('empty-body').html(`<p class="label label--alt">${msg}</p>`);
    $footer.fadeOut();
    $icon.fadeOut();

  }

  updateMinicart() {

    let ctx = this;
    let $elem = $(this.SELECTORS.main);

    return $.ajax({
      url: $elem.data('href'),
      dataType: "html",
      success: function (resp) {
        console.log('Minicart updated...');
        $elem.html(resp);
        ctx.updateQty();
        ctx.$emit(ctx.$customEvents.MINICART_EVENTS.update, { html: resp } );
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  removeProduct(el) {

    let ctx = this;
    let $elem = $(el);
    let $main = $elem.closest(ctx.SELECTORS.main)

    $.ajax({
      url: $elem.data('href'),
      dataType: "json",
      type: 'POST',
      success: function (resp) {

        let item = $elem.closest('.product-item');
        let qty = resp.count;
        let tot = resp.totalFormattedPrice;

        item.addClass(ctx.CLASSES.removing);
        setTimeout(() => {
          item.remove()
        }, 800);
        $main.find('.tot-price').text(tot);

        ctx.updateMinicart();

        if (resp.count > 0) {
          ctx.container.find('.qty-icon').text(qty);
        } else {
          setTimeout(() => {
            ctx.showEmptyMsg($main)
          }, 800);
          ;
        }
        ctx.updateMinicart();
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });

  }

  desktopBehaviour() {
    this.$on('mouseenter.minicart', ({event}) => {
      clearTimeout(this.timeout);
      //update wishlist only on the first over
      this.firstUpdate(event, 'lg');
      this.$emit(this.$customEvents.MINICART_EVENTS.enter);

    }, 'body', `${this.SELECTORS.container}`);

    this.$on('mouseleave.minicart', ({event}) => {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.close, {
        source: event.currentTarget,
        res: 'lg'
      });
      this.$emit(this.$customEvents.MINICART_EVENTS.exit);
    }, 'body', `${this.SELECTORS.container}`);

    this.$on('keyup.minicart', ({event}) => {
      if (event.which === 13) {
        const firstFocusable = this.$getFirstFocusable(event.currentTarget);
        this.firstUpdate(event, 'md');
        setTimeout(() => {
          firstFocusable.focus();
        }, 200)
      }
    }, 'body', this.SELECTORS.container);

  }

  tabletBehaviour() {
    this.$on('click.minicart', ({event}) => {
      this.firstUpdate(event, 'md')
    }, 'body', `${this.SELECTORS.container} .dropdown-toggle`);
  }

  mobileBehaviour() {
    this.$on('click.minicart', ({event}) => {
      this.firstUpdate(event, 'sm')
    }, 'body', `${this.SELECTORS.container} .dropdown-toggle`);
  }

  firstUpdate(event, br) {
    if (!this.updated) {
      this.updateMinicart().then(res => {
        this.$emit(this.$customEvents.DROPDOWN_EVENTS.open, {
          source: event.currentTarget,
          res: br
        });
        this.updated = true;
      });

    } else {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.open, {
        source: event.currentTarget,
        res: br
      });
    }
  }

  bindEvents() {

    let ctx = this;

    $('body').on('click.removeProduct', ctx.SELECTORS.remove, function () {
      ctx.removeProduct(this);
    });

    this.$on('mouseenter.minicart', () => {
      clearTimeout(this.timeout);
    }, 'body', `${this.SELECTORS.main}, ${this.SELECTORS.container}`);


    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.updateMinicart().then(res => {
          if (!this.$matchMedia('sm', null)) {
            this.openMinicart();
          }
        });
      }, 800);

    })

    if (this.$matchMedia(null, 'lg')) {
      this.desktopBehaviour();
    } else if (this.$matchMedia('lg', 'sm')) {
      this.tabletBehaviour();
    } else {
      this.mobileBehaviour()
    }

    window.addEventListener('resize', () => {
      if (this.$matchMedia(null, 'lg')) {
        this.desktopBehaviour();
      }
      /* else if (this.$matchMedia('lg', 'sm')) {
        this.tabletBehaviour();
      } else {
        this.mobileBehaviour()
      }*/
    });


  }

  render() {
    this.bindEvents();
    // if (this.container.length !== 0) {
    //   this.updateMinicart();
    // }
  }
}
